import type { ReactElement } from "react";
import { Navigate } from "@/lib/router-compat";
import { usePageVisibility } from "@/hooks/usePageVisibility";
import { useIsAdmin } from "@/hooks/useIsAdmin";
import type { PageKey } from "@/config/pageRegistry";

// Admins bypass the gate so they can preview disabled pages via direct URL.
const PageGate = ({ pageKey, children }: { pageKey: PageKey; children: ReactElement }) => {
  const { isEnabled } = usePageVisibility();
  const { isAdmin } = useIsAdmin();
  if (!isAdmin && !isEnabled(pageKey)) return <Navigate to="/" replace />;
  return children;
};

export default PageGate;
